export const gmbImportEditorStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '#bulkEditContainer': {
    '& h3': {
      fontSize: 14,
    },
    '& .panel-title': {
      fontSize: 14,
    },
    '& .steps-wizard__content.clearfix': {
      marginTop: 10,
      marginBottom: 10,
    },
    '& .select-account-grid': {
      '& .table-bordered>thead>tr.grid-toolbar th': {
        borderBottom: {
          color: '#ddd',
          width: 1,
          style: 'solid',
        },
        borderLeft: 'none',
        borderRight: 'none',
      },
      '& input[type=radio]:before': {
        content: 'none',
      },
      '& input[type=radio]:after': {
        content: 'none',
      },
      '& .viewport': {
        overflow: 'visible !important',
      },
      '& table.table.table-bordered': {
        border: 'none',
      },
      '& .search-box': {
        '& button': {
          width: 30,
          marginTop: 1,
          backgroundColor: '#fff',
          border: 'none',
        },
        '& input': {
          height: 32,
          marginRight: -32,
          paddingRight: 32,
          fontWeight: 400,
        },
      },
    },
    '& .filter_search_icon_small': {
      fontFamily: iconFontFamily,
      color: palette.themePrimary,
      fontSize: 14,
    },
    '& .filter_search_icon_small:before': {
      content: '"\\E721"',
    },
    '& .filter-query-seperator': {
      float: 'left',
      width: 14,
    },
    '& .filter-query-remove': {
      marginTop: 6,
      float: 'left',
      padding: 0,
    },
    '& .filter-query-or': {
      marginTop: 5,
      padding: 0,
    },
    '& .filter-query-attribute': {
      marginBottom: 5,
    },
  },
});
